export default "__VITE_ASSET__ChEYBZlO__"